import { gql } from '@apollo/client';

export const SET_ONBOARDING_BILLING_PLAN = gql`
  mutation SetOnboardingBillingPlan($plan: String!) {
    setOnboardingBillingPlan(plan: $plan) {
      id
      billingPlan
    }
  }
`;
